module.exports = "/_next/static/pages/about/Fragments/65bd1c33339615e8c834ac91521282e7.jpg";